import environment from '@/utils/environment';

const AdBlockDetection = () =>
  environment.isPreviewServer() || environment.isDev() ? null : (
    <script
      data-cookieconsent="ignore"
      // eslint-disable-next-line react/no-danger
      dangerouslySetInnerHTML={{
        __html: `
  (function () {
    var baitPath = 'https://sst.gostudent.org/ads-min.js';
    var pixelPath = 'https://sst.gostudent.org/4dchk';

    var el = document.createElement('script');
    el.src = baitPath;
    document.body.appendChild(el);

    var ga4Blocked = false;
    var fbBlocked = false;
    var gadsBlocked = false;

    window.addEventListener('load', function () {
      fetch('https://www.googletagmanager.com/gtag/js?id=G-XXXXXXX', { method: 'HEAD', mode: 'no-cors' })
        .catch(function () { ga4Blocked = true; })
        .finally(function () {
          fetch('https://connect.facebook.net/en_US/fbevents.js', { method: 'HEAD', mode: 'no-cors' })
            .catch(function () { fbBlocked = true; })
            .finally(function () {
              fetch('https://googleads.g.doubleclick.net/pagead/viewthroughconversion/', { method: 'HEAD', mode: 'no-cors' })
                .catch(function () { gadsBlocked = true; })
                .finally(function () {
                  var params = {
                    ads_blocked: !document.querySelector('#GxsCRdhiJi'),
                    gtm_blocked: !(window.google_tag_manager && window.google_tag_manager.dataLayer),
                    ga4_blocked: ga4Blocked,
                    fb_blocked: fbBlocked,
                    gads_blocked: gadsBlocked
                  };

                  var cid = Math.floor((Math.random() * 1000000) + 1) + '_' + new Date().getTime();
                  var img = document.createElement('img');
                  img.style = 'width: 1; height: 1; display: none;';
                  img.src = pixelPath + '?client_id=' + cid + '&' + Object.keys(params).reduce(function (acc, cur) {
                    return acc.concat(cur + '=' + params[cur]);
                  }, []).join('&');
                  document.body.appendChild(img);
              });
          });
      });
    });
  })();`,
      }}
    />
  );

export default AdBlockDetection;
